import classNames from 'classnames'
import css from '../AuthorProfile.styles.scss'

const Awards = ({ author }) => {
  if (author.awards && author.awards.length > 0) {
    return (
      <div id="awards" className={classNames(css.authorProfileSection)}>
        <h2>Awards</h2>
        <ul>
          {author.awards.map((award, i) => (
            <li key={i}>
              <strong>{award.issuingOrganization}</strong> - {award.name}
            </li>
          ))}
        </ul>
      </div>
    )
  } else {
    return null
  }
}

export default Awards
